<template>
  <div class="seating-selection-info">
    <h3 class="seating-selection-info__title" v-t="'seating_selection_info.your_selection'"/>
    <div class="seating-selection-info__details shopping-cart-item__value shopping-cart-item__value--seat-details" v-for="(seats, key) in seatSelectionDetailsRender">
      <span class="seat-details__label" v-t="'seating_selection_info.row'"/>
      <span class="seat-details__highlight">{{ key }}</span>
      <span class="seat-details__label" v-t="'seating_selection_info.seat'"/>
      <span class="seat-details__highlight" v-for="seat in seats">{{ seat }}</span>
      <span class="seat-details__label" v-t="'seating_selection_info.selected'"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "seating-selection-info",
  props: {
    seatSelectionDetails: {
      type: Object,
      required: false
    }
  },
  computed: {
    seatSelectionDetailsRender() {
      let aggregatedRows = {}
      
      // Aggregate rows together, by default each Row & Seat combo is separate
      Object.entries(this.seatSelectionDetails).forEach(entry => {
        let row = entry[1]['row']
        let seat = entry[1]['seat']

        if(!(row in aggregatedRows)) {
          this.$set(aggregatedRows, row, [])
        }

        aggregatedRows[row].push(seat);
      })

      // Once we've aggregated the rows (e.g. A: [1, 5, 2, 7], B: [4, 2, 3])
      // Sort them (e.g. A: [1, 2, 5, 7], B: [2, 3, 4])
      Object.values(aggregatedRows).forEach(seatArray => {
        seatArray.sort((a, b) => {
          return parseInt(a) > parseInt(b)
        })
      });

      return aggregatedRows
    }
  }
}
</script>